/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Root_Error_Boundary_Alert_DescriptionInputs */

const en_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload Glider to try again.`)
};

const de_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie Glider neu, um es erneut zu versuchen.`)
};

const pt_br2_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregue o Glider para tentar novamente.`)
};

const tr_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider'ı yeniden yükleyip tekrar deneyin.`)
};

const zh_cn2_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新加载 Glider 后再试。`)
};

const zh_hk2_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新載入 Glider 再試。`)
};

const ko_kr2_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider를 새로고침하고 다시 시도하세요.`)
};

const ru_ru2_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузите Glider и попробуйте снова.`)
};

const es_419_components_root_error_boundary_alert_description = /** @type {(inputs: Components_Root_Error_Boundary_Alert_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarga Glider para intentarlo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Reload Glider to try again." |
*
* @param {Components_Root_Error_Boundary_Alert_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_root_error_boundary_alert_description = /** @type {((inputs?: Components_Root_Error_Boundary_Alert_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Root_Error_Boundary_Alert_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_root_error_boundary_alert_description(inputs)
	if (locale === "de") return de_components_root_error_boundary_alert_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_root_error_boundary_alert_description(inputs)
	if (locale === "tr") return tr_components_root_error_boundary_alert_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_root_error_boundary_alert_description(inputs)
	if (locale === "zh-HK") return zh_hk2_components_root_error_boundary_alert_description(inputs)
	if (locale === "ko-KR") return ko_kr2_components_root_error_boundary_alert_description(inputs)
	if (locale === "ru-RU") return ru_ru2_components_root_error_boundary_alert_description(inputs)
	return es_419_components_root_error_boundary_alert_description(inputs)
});